import { useEffect, useState } from 'react';

import { Badge, Button } from '@mui/material';

import PropTypes from 'prop-types';

import { useRouter } from 'next/router';

import _ from 'lodash';

import { NumberSpinner } from '../shared';

const NumberOfGuestsFilterButton = (props) => {
    const { children, onChange, numberOfGuests } = props;
    const [openModal, setOpenModel] = useState(false);
    const [buildingBadgeCount, setBuildingBadgeCount] = useState(null);
    const [selectedNumberOfGuests, setSelectedNumberOfGuests] = useState(0);

    const router = useRouter();
    const { query } = router;

    useEffect(() => {
        getGuestCountParamFromQuery();
        checkBadgeCount();
    }, [query]);

    useEffect(() => {
        if (numberOfGuests !== 0) {
            setSelectedNumberOfGuests(numberOfGuests);
        } else {
            setSelectedNumberOfGuests(0);
        }
    }, [numberOfGuests]);

    const getGuestCountParamFromQuery = () => {
        const guestCountParam = _.get(query, 'guestCount');
        if (guestCountParam) {
            setSelectedNumberOfGuests(guestCountParam);
        } else {
            setSelectedNumberOfGuests(0);
        }
    };

    const checkBadgeCount = () => {
        let count = 0;
        const guestCountParam = _.get(query, 'guestCount');
        if (guestCountParam && guestCountParam !== 'Any') {
            count += 1;
        }

        setBuildingBadgeCount(count);
    };

    const onFilterClick = () => {
        setOpenModel(true);
    };

    const onModalClose = () => {
        setOpenModel(false);
    };

    const onNumberOfGuestsChange = (value) => {
        let guestCount = value;
        if (value === 0) {
            guestCount = 'Any';
        }
        setSelectedNumberOfGuests(guestCount);

        if (onChange) {
            onChange(guestCount);
        }
    };

    return (
        <div className='number-of-guests-filter-container'>
            <Button
                id="guest-count-filter-button"
                badge={buildingBadgeCount > 0 ? buildingBadgeCount : 0}
                className={buildingBadgeCount > 0 ? 'guest-count-filter-badge' : 'guest-count-filter-no-badge'}
                onClick={onFilterClick}
            >
                <Badge badgeContent={buildingBadgeCount}>
                    {children}
                </Badge>
            </Button>
            {openModal && (
                <div>
                    <div className='number-of-guests-filter-overlay' onClick={onModalClose} />
                    <div className='number-of-guests-filter-modal-container'>
                        <div className='number-of-guests-filter-number-spinner-container'>
                            <h6>No. of Guests</h6>
                            <NumberSpinner
                                type="filter"
                                min={0}
                                max={10}
                                value={
                                    selectedNumberOfGuests !== 'Any' ? selectedNumberOfGuests : 0
                                }
                                onChange={onNumberOfGuestsChange}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

NumberOfGuestsFilterButton.propTypes = {
    children: PropTypes.string,
    numberOfGuests: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

    onChange: PropTypes.func,
};

export default NumberOfGuestsFilterButton;


